import React from 'react';
import { Box } from '@mui/material';

import { CollapseAllButton } from './CollapseAllButton';
import { ExpandAllButton } from './ExpandAllButton';

interface ExpandCollapseButtonsProps {
  readonly rowId: string;
  readonly expandRows: (rowIds: readonly string[]) => void;
  readonly collapseRows: (rowIds: readonly string[]) => void;
  readonly expandableDescendantRowIds: readonly string[];
  readonly expandedRowIds: readonly string[];
}

const buttonSx = {
  height: 20,
  width: 20,
  ml: 0.5,
  mr: 0.5,
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
};

export function ExpandCollapseButtons(props: ExpandCollapseButtonsProps) {
  const { rowId, expandableDescendantRowIds, expandedRowIds, expandRows, collapseRows } = props;
  const allRowsExpanded = expandableDescendantRowIds.every((rowId) => expandedRowIds.includes(rowId));
  return allRowsExpanded ? (
    <Box sx={buttonSx}>
      <CollapseAllButton
        collapseAll={(rowIds) => collapseRows(rowIds)}
        allCollapsableRowIds={[rowId].concat(expandableDescendantRowIds)}
      />
    </Box>
  ) : (
    <Box sx={buttonSx}>
      <ExpandAllButton
        expandAll={(rowIds) => expandRows(rowIds)}
        allExpandableRowIds={[rowId].concat(expandableDescendantRowIds)}
      />
    </Box>
  );
}
